var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _circle, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendlePtWsteth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3525_843)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 250C194.036 250 250 194.036 250 125C250 55.9644 194.036 0 125 0C55.9644 0 0 55.9644 0 125C0 194.036 55.9644 250 125 250Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7185 117.709L78.5269 119.496C64.8232 140.946 67.8023 168.949 86.2724 186.823C96.4012 197.548 110.701 202.91 125 202.91C125 202.91 125 202.91 79.7185 117.709Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M125 143.329L79.7183 117.113C125 202.91 125 202.91 125 202.91C125 184.44 125 162.991 125 143.329Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M170.282 117.709L171.473 119.496C185.177 140.946 182.198 168.949 163.728 186.823C153.003 197.548 139.299 202.91 125 202.91C125 202.91 125 202.91 170.282 117.709Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125 143.329L170.282 117.113C125 202.91 125 202.91 125 202.91C125 184.44 125 162.991 125 143.329Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125 85.5352V130.221L164.323 108.176L125 85.5352Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M125 85.5352L85.6768 108.176L125 130.221V85.5352Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125 48L85.6768 108.177L125 85.5361V48Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M125 85.5361L164.323 108.177L125 48V85.5361Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196 250C225.823 250 250 225.823 250 196C250 166.177 225.823 142 196 142C166.177 142 142 166.177 142 196C142 225.823 166.177 250 196 250Z",
    fill: "#131517"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3525_843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 142,
    width: 109,
    height: 108
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.81 250C225.633 250 249.81 225.823 249.81 196C249.81 166.177 225.633 142 195.81 142C165.986 142 141.81 166.177 141.81 196C141.81 225.823 165.986 250 195.81 250Z",
    fill: "#131517"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3525_843)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M171.516 276.997C187.923 276.997 201.224 263.696 201.224 247.289C201.224 230.882 187.923 217.582 171.516 217.582C155.11 217.582 141.809 230.882 141.809 247.289C141.809 263.696 155.11 276.997 171.516 276.997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3525_843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 145,
    width: 7,
    height: 80
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.249 224.678V145.062H174.871V224.678H168.249Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3525_843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.81 196C249.81 225.824 225.633 250 195.81 250C165.986 250 141.81 225.824 141.81 196C141.81 166.177 165.986 142 195.81 142C225.633 142 249.81 166.177 249.81 196Z",
    fill: "white"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 54,
    r: 54,
    fill: "#D5EBFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.787 35.239C184.227 35.239 186.382 35.788 188.253 36.886C190.164 37.984 191.628 39.5293 192.645 41.522C193.702 43.5147 194.231 45.792 194.231 48.354C194.231 50.8753 193.702 53.112 192.645 55.064C191.628 56.9753 190.164 58.4597 188.253 59.517C186.382 60.5743 184.227 61.103 181.787 61.103H175.199C174.995 61.103 174.894 61.2047 174.894 61.408V77.268C174.894 77.4713 174.812 77.6543 174.65 77.817C174.528 77.939 174.365 78 174.162 78H167.025C166.821 78 166.638 77.939 166.476 77.817C166.354 77.6543 166.293 77.4713 166.293 77.268V35.971C166.293 35.7677 166.354 35.605 166.476 35.483C166.638 35.3203 166.821 35.239 167.025 35.239H181.787ZM180.384 54.271C181.97 54.271 183.23 53.7627 184.166 52.746C185.142 51.6887 185.63 50.2857 185.63 48.537C185.63 46.7477 185.142 45.3243 184.166 44.267C183.23 43.2097 181.97 42.681 180.384 42.681H175.199C174.995 42.681 174.894 42.7827 174.894 42.986V53.966C174.894 54.1693 174.995 54.271 175.199 54.271H180.384ZM225.417 35.3C225.62 35.3 225.783 35.3813 225.905 35.544C226.068 35.666 226.149 35.8287 226.149 36.032V42.01C226.149 42.2133 226.068 42.3963 225.905 42.559C225.783 42.681 225.62 42.742 225.417 42.742H216.145C215.942 42.742 215.84 42.8437 215.84 43.047V77.268C215.84 77.4713 215.759 77.6543 215.596 77.817C215.474 77.939 215.311 78 215.108 78H207.971C207.768 78 207.585 77.939 207.422 77.817C207.3 77.6543 207.239 77.4713 207.239 77.268V43.047C207.239 42.8437 207.137 42.742 206.934 42.742H197.967C197.764 42.742 197.581 42.681 197.418 42.559C197.296 42.3963 197.235 42.2133 197.235 42.01V36.032C197.235 35.8287 197.296 35.666 197.418 35.544C197.581 35.3813 197.764 35.3 197.967 35.3H225.417Z",
    fill: "#1C293A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3525_843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendlePtWsteth);
export default __webpack_public_path__ + "static/media/pendle-pt-wsteth.3b7eaab7274d0ebe190b65afb74ad8d5.svg";
export { ForwardRef as ReactComponent };